import { TabPanel, TabView } from 'primereact/tabview'
import React from 'react'
import Demographic_1 from './ReprotTabs/Demographic_1'
import Measure_2 from './ReprotTabs/Measure_2'
import MeasureSocial_3 from './ReprotTabs/MeasureSocial_3'
import Screening_4 from './ReprotTabs/Screening_4'
import Assessment_5 from './ReprotTabs/Assessment_5'
import FollowUps_6 from './ReprotTabs/FollowUps_6'
import GetGoingActivity_7 from './ReprotTabs/GetGoingActivity_7'
import CalActivities_8 from './ReprotTabs/CalActivities_8'
import PrsCompliance_9 from './ReprotTabs/PrsCompliance_9'
import Suciadality_10 from './ReprotTabs/Suciadality_10'

const Reports = () => {
  return (
    <div className="container">
      <span className="heading-page mt-0">Reports</span>

              <TabView scrollable className='mt-4'>
                <TabPanel header="Demographic details of participants">
                    <Demographic_1/>
                </TabPanel>

                <TabPanel header="Measure of Stress ">
                  <Measure_2/>
                </TabPanel>

                <TabPanel header="Measure of Social support ">
                  <MeasureSocial_3/>
                </TabPanel>

                <TabPanel header="Screening using PHQ-2">
                  <Screening_4/>
                </TabPanel>

                <TabPanel  header="Assessment using PHQ-9">
                  <Assessment_5/>
                </TabPanel>

                <TabPanel  header="Follow-up questions_HCW">
                  <FollowUps_6/>
                </TabPanel>

                <TabPanel  header="Get Going, Keep Doing activity">
                  <GetGoingActivity_7/>
                </TabPanel>

                 <TabPanel  header="Activity Followup ">
                  <CalActivities_8/>
                </TabPanel>

                 <TabPanel  header="Compliance">
                  <PrsCompliance_9/>
                </TabPanel>

                <TabPanel  header="Suicidality screening">
                  <Suciadality_10/>
                </TabPanel>
        </TabView>
    </div>
  )
}

export default Reports
